/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ServiceAdminSearchOrganizationsQueryVariables = Types.Exact<{
  searchTerm: Types.Scalars['String'];
  pageSize?: Types.InputMaybe<Types.Scalars['Int']>;
  pageNumber?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type ServiceAdminSearchOrganizationsQuery = { __typename: 'Query', serviceAdminSearchOrganizations: { __typename: 'ServiceAdminOrganizationSearchPayload', totalCount: number, results: Array<{ __typename: 'ServiceAdminOrganizationSearchResult', id: string, name: string, handle: string, displayCount: number, onboardedAdminEmail?: string | null, createdAt: any, proStoreConnected: boolean, developerAccess: boolean, accessState: Types.ServiceAdminGlobalSearchAccessState }> } };


export const ServiceAdminSearchOrganizationsDocument = gql`
    query ServiceAdminSearchOrganizations($searchTerm: String!, $pageSize: Int, $pageNumber: Int) {
  serviceAdminSearchOrganizations(
    searchTerm: $searchTerm
    pageSize: $pageSize
    pageNumber: $pageNumber
  ) {
    totalCount
    results {
      id
      name
      handle
      displayCount
      onboardedAdminEmail
      createdAt
      proStoreConnected
      developerAccess
      accessState
    }
  }
}
    `;

/**
 * __useServiceAdminSearchOrganizationsQuery__
 *
 * To run a query within a React component, call `useServiceAdminSearchOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceAdminSearchOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceAdminSearchOrganizationsQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      pageSize: // value for 'pageSize'
 *      pageNumber: // value for 'pageNumber'
 *   },
 * });
 */
export function useServiceAdminSearchOrganizationsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ServiceAdminSearchOrganizationsQuery, ServiceAdminSearchOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ServiceAdminSearchOrganizationsQuery, ServiceAdminSearchOrganizationsQueryVariables>(ServiceAdminSearchOrganizationsDocument, options);
      }
export function useServiceAdminSearchOrganizationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ServiceAdminSearchOrganizationsQuery, ServiceAdminSearchOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ServiceAdminSearchOrganizationsQuery, ServiceAdminSearchOrganizationsQueryVariables>(ServiceAdminSearchOrganizationsDocument, options);
        }
export type ServiceAdminSearchOrganizationsQueryHookResult = ReturnType<typeof useServiceAdminSearchOrganizationsQuery>;
export type ServiceAdminSearchOrganizationsLazyQueryHookResult = ReturnType<typeof useServiceAdminSearchOrganizationsLazyQuery>;
export type ServiceAdminSearchOrganizationsQueryResult = ApolloReactCommon.QueryResult<ServiceAdminSearchOrganizationsQuery, ServiceAdminSearchOrganizationsQueryVariables>;